import script from "./ElementPositionPanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./ElementPositionPanel.vue?vue&type=script&lang=ts&setup=true"

import "./ElementPositionPanel.vue?vue&type=style&index=0&id=260cacb4&lang=scss&scoped=true"

import exportComponent from "D:\\huishi-ppt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-260cacb4"]])

export default __exports__